/** @format */

import Vue from "vue";
import Router from "vue-router";


import eventDetails from "@/router/eventRoutes";
import internationalEventDetails from "@/router/internationalEventRoutes";

import hotelDetails from "@/router/hotelRoutes";
import eGifts from "./egifts.Routes";
import flights from "./flightRoutes";

Vue.use(Router);
export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  },
  routes: [
    {
      path: '/',
      name: 'Home',
      component: () => import('@/views/HomeNew'),
      meta: {
        breadcrumb: 'Home',
      },
    },
    {
      path: '/login',
      name: 'Login',
      component: () => import('@/views/Login'),
    },
    {
      path: '/scan-qr-code',
      name: 'QRReader',
      component: () => import('@/views/QRReader'),
    },
    {
      path: '/profile/verify-email/:verifiedCode',
      name: 'emailVerified',
      component: () => import('@/components/Account/EmailVerified'),
    },
    {
      path: '/profile',
      component: () => import('@/views/Profile'),

      children: [
        {
          path: '',
          name: 'Profile',
          component: () => import('@/components/Account/EditProfile'),
        },
        {
          path: 'change-password',
          name: 'changePassword',
          component: () => import('@/components/Account/ChangePassword'),
        },
        {
          path: 'reward-points',
          name: 'rewardPoints',
          component: () => import('@/components/Account/RewardPoints'),
        },
        {
          path: 'my-bookings',
          name: 'myBookings',
          component: () => import('@/components/Account/MyBookings'),
        },
      ],
    },
    {
      path: '/register',
      name: 'Register',
      component: () => import('@/views/Register'),
    },
    {
      path: '/forgot-password',
      name: 'ForgotPassword',
      component: () => import('@/views/ForgotPassword'),
    },
    {
      path: '/search-results/:slug',
      name: 'searchResults',
    },
    {
      path: '/events',
      name: 'eventsIndex',
      component: () => import('@/views/Events'),
      props: true,
      children: [
        {
          path: ':page',
          name: 'events',
          component: () => import('@/components/Events/Index'),
          props: true,
        },
      ],
    },
    {
      path: '/international/events',
      component: () => import('@/views/InternationalEvents'),
      children: [
        {
          path: ':page?', // 👈 optional page
          component: () => import('@/components/InternationalEvents/Index'),
          props: true,
        },
      ],
    },
    {
      path: '/international/event/:slug',
      meta: { breadcrumb: 'international/event' },
      component: () => import('@/views/InternationalEvent'),
      props: true,
      children: internationalEventDetails,
    },
    {
      path: '/international/events/find',
      name: 'internationalEventFind',
      component: () => import('@/views/InternationalEventFind'),
      props: true,
    },
    

    {
      path: '/event/:slug',
      meta: {
        breadcrumb: 'event',
      },
      component: () => import('@/views/Event'),
      props: true,
      children: eventDetails,
    },
    {
      path: '/hotel/:slug',
      name: '',
      component: () => import('@/views/Hotel'),
      props: true,
      children: hotelDetails,
      meta: {
        breadcrumb: 'hotel',
      },
    },
    {
      path: '/hotel/:slug/booking/payment/:paymentMethod/:response',
      name: 'signix-hotel-booking-confirmation',
      component: () => import('@/components/Hotel/Details/OrderConfirmation'),
      props: true,
    },
    {
      path: '/international/event/:slug/booking/payment/:paymentMethod/:response',
      name: 'international-event-booking-confirmation',
      component: () =>
        import(
          '@/components/InternationalEvent/TicketBooking/InternationalEventConfirmation'
        ),
      props: true,
    },

    {
      path: '/hotels',
      name: 'hotelsIndex',
      component: () => import('@/views/Hotels'),
      props: true,
      children: [
        {
          path: ':destination?/:page',
          name: 'hotels',
          component: () => import('@/components/Hotels/Index'),
          props: true,
        },
      ],
    },

    {
      path: '/about-us',
      name: 'About',
      component: () => import('@/views/About'),
    },

    // Updated Route Configuration
    {
      path: '/blogs',
      component: () => import('@/views/Blogs'),
      props: true,
      children: [
        {
          path: '',
          name: 'Blog',
          component: () =>
            import('@/components/BlogsAndNews/Blogs/BlogsListing'),
          props: true,
        },
        {
          path: ':page(\\d+)',
          name: 'BlogPaginated',
          component: () =>
            import('@/components/BlogsAndNews/Blogs/BlogsListing'),
          props: true,
        },
        {
          path: 'blog/:slug',
          name: 'blogDetail',
          component: () => import('@/components/BlogsAndNews/Blogs/BlogDetail'),
          props: true,
        },
      ],
    },
    // Updated Route Configuration
    {
      path: '/interviews',
      component: () => import('@/views/Interview'),
      props: true,
      children: [
        {
          path: '',
          name: 'Interview',
          component: () =>
            import('@/components/BlogsAndNews/Interview/InterviewListing'),
          props: true,
        },
        {
          path: ':page(\\d+)',
          name: 'InterviewPaginated',
          component: () =>
            import('@/components/BlogsAndNews/Interview/InterviewListing'),
          props: true,
        },
        {
          path: 'interview/:slug',
          name: 'interviewDetail',
          component: () =>
            import('@/components/BlogsAndNews/Interview/InterviewDetail'),
          props: true,
        },
      ],
    },
    {
      path: '/newsroom',
      component: () => import('@/views/Newsroom'),
      props: true,
      children: [
        {
          path: '',
          name: 'NewsRoom',
          component: () =>
            import('@/components/BlogsAndNews/NewsRoom/NewsRoomListing'),
          props: true,
        },
        {
          path: 'news',
          name: 'AllNewsRoom',
          component: () =>
            import('@/components/BlogsAndNews/NewsRoom/AllNewsRoom'),
          props: true,
        },
        {
          path: 'news/:page(\\d+)',
          name: 'AllNewsRoomPaginated',
          component: () =>
            import('@/components/BlogsAndNews/NewsRoom/AllNewsRoom'),
          props: true,
        },
        {
          path: '/newsroom/:slug',
          name: 'NewsRoomDetail',
          component: () =>
            import('@/components/BlogsAndNews/NewsRoom/NewsRoomDetail'),
          props: true,
        },
      ],
    },
    {
      path: '/e-gift-card',
      // name: "E-Gift Voucher",
      component: () => import('@/views/EGiftVoucher'),
      props: true,

      children: eGifts,
    },
    {
      path: '/flight',
      name: 'flightIndex',

      component: () => import('@/views/FlightBooking'),
      props: true,
      children: flights,
    },

    // {
    //   path: "/e-gift-voucher",
    //   name: "E-Gift Voucher",
    //   component: () => import('@/views/EGiftVoucher'),
    // },
    {
      path: '/ambassador-program',
      name: 'AmbassadorProgram',
      component: () => import('@/views/AmbassadorProgram'),
    },
    {
      path: '/giftcard-balance',
      name: 'GiftCardBalance',
      component: () => import('@/views/GiftCardBalance'),
    },
    {
      path: '/apply-job',
      name: 'ApplyJob',
      component: () => import('@/views/ApplyJob'),
    },
    {
      path: '/claim-refund',
      name: 'ClaimRefund',
      component: () => import('@/views/ClaimRefund'),
    },
    {
      path: '/our-services',
      name: 'OurServices',
      component: () => import('@/views/OurServices'),
    },
    {
      path: '/cookie-terms',
      name: 'Cookie',
      component: () => import('@/views/Cookie'),
    },
    {
      path: '/refund-terms',
      name: 'Refunds',
      component: () => import('@/views/Refunds'),
    },
    {
      path: '/terms-and-condition',
      name: 'TermsAndCondition',
      component: () => import('@/views/TermsAndCondition'),
    },
    {
      path: '/terms-of-use',
      name: 'TermsOfUse',
      component: () => import('@/views/TermsOfUse'),
    },
    {
      path: '/what-we-do',
      name: 'WhatWeDo',
      component: () => import('@/views/WhatWeDo'),
    },
    {
      path: '/contact',
      name: 'Contact',
      component: () => import('@/views/Contact'),
    },
    {
      path: '/sell-tickets',
      name: 'SellTickets',
      component: () => import('@/views/Contact'),
    },
    {
      path: '/our-pricing',
      name: 'OurPricing',
      component: () => import('@/views/Contact'),
    },
    {
      path: '/why-us',
      name: 'WhyChoose',
      component: () => import('@/views/WhyChoose'),
    },
    {
      path: '/careers',
      name: 'Career',
      component: () => import('@/views/Career'),
    },
    {
      path: '/privacy-policy',
      name: 'PrivacyPolicy',
      component: () => import('@/views/PrivacyPolicy'),
    },
    {
      path: '/our-platform',
      name: 'OurPlatforms',
      component: () => import('@/views/OurPlatforms'),
    },
    {
      path: '/download-ticket/:slug',
      name: 'DownloadPDF',
      component: () => import('@/views/DownloadPDF'),
    },
    {
      path: '/view-ticket/:slug',
      name: 'ViewTicket',
      component: () => import('@/views/ViewTickets'),
    },

    {
      path: '*',
      component: () => import('@/views/NotFound'),
    },
  ],
});
